import { FC } from "react";
import { useDispatch } from "react-redux";

import type { AppDispatch } from "store";
import { clearIndicators } from "../../model";

import styles from "../select-indicators/SelectIndicators.module.css";

interface Props {
  count: number;
}

export const DeleteAllIndicatorsButton: FC<Props> = ({ count }) => {
  const dispatch = useDispatch<AppDispatch>();

  return (
    <button
      className={styles.deleteAll}
      onClick={() => dispatch(clearIndicators())}
    >
      Delete all ({count})
    </button>
  );
};
